import React, { useEffect } from 'react';
import logo from '../../../assets/images/home/logo.gif';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaPinterestP } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';


const Footer = () => {

    const navigate = useNavigate();

    return (
        <div className='footer-sect bg-primary'>
            <div className='container'>
                <div className='row'>
                    <div className='col-xl-4 col-lg-12 col-md-6'>
                        <div data-aos="fade-up">
                            <div className='fot-logo'>
                                <img src={logo} alt='logo' className='mb-3' />
                                <p className='text-white'>Learn the Skillz that Matter</p>
                                <ul className='fot-ul'>
                                    <li>
                                        <a href="https://www.tiktok.com/@sharkskillzz?_t=8s6wDoClYDg&_r=1" className='text-secondary'> <FaTiktok /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/sharkskillzz/" className='text-secondary'> <FaInstagram /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/SharkSkillz" className='text-secondary'> <FaFacebookF /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/@SharkSkillzz" className='text-secondary'> <FaYoutube /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/sharkskillz/" className='text-secondary'> <FaLinkedin /></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-2 col-lg-12 col-md-6'>
                        <div data-aos="fade-down">
                            <h4 className='text-white mb-4'>Quick Links</h4>
                            <ul className="list-unstyled">
                                <li className='mb-2'>
                                    <p
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            navigate(`/privacy-policy`);
                                        }}
                                        className='text-white a-decuration-text showing-cursor'
                                    >
                                        <span className='me-2 text-secondary'><FaChevronRight /></span> Privacy Policy
                                    </p>
                                </li>
                                <li className='mb-2'>
                                    <p
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            navigate(`/terms-of-service`);
                                        }}
                                        className='text-white a-decuration-text showing-cursor'
                                    >
                                        <span className='me-2 text-secondary'><FaChevronRight /></span> Terms & Conditions
                                    </p>
                                </li>
                                <li className='mb-2'>
                                    <p
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            navigate(`/data-deletion-policy`);
                                        }}
                                        className='text-white a-decuration-text showing-cursor'
                                    >
                                        <span className='me-2 text-secondary'><FaChevronRight /></span> Data Deletion Policy
                                    </p>
                                </li>
                                <li className='mb-2'>
                                    <p
                                        onClick={() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            navigate(`/support`);
                                        }}
                                        className='text-white a-decuration-text showing-cursor'
                                    >
                                        <span className='me-2 text-secondary'><FaChevronRight /></span> Support
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-xl-3 col-lg-12 col-md-6'>
                        <div data-aos="fade-up">
                            <h4 className='text-white mb-4'>Get In Touch</h4>
                            <ul className="list-unstyled get-touch">
                                <li className='mb-3'>
                                    <span className='me-2 text-secondary'><FaMapMarkerAlt /></span>
                                    <span className='text-white'>London</span>
                                </li>
                                {/* <li className='mb-3'>
                                    <span className='me-2 text-secondary'><FaPhoneAlt /></span>
                                    <a href="tel:+1234-567-8905" className='text-white a-decuration-text'>+1234-567-8905</a>
                                </li> */}
                                <li className='mb-3'>
                                    <span className='me-2 text-secondary'><FaEnvelope /></span>
                                    <a href="mailto:skillz@sharkskillz.com" className='text-white a-decuration-text'>skillz@sharkskillz.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-xl-3 col-lg-12 col-md-6'>
                        <div data-aos="fade-down">
                            <h4 className='text-white mb-4'>Get App From Store</h4>
                            <ul className='fot-app-btn'>
                                <li>
                                    <a target='_blank' href="https://play.google.com/store/apps/details?id=com.gologonow.sharkSkills&pcampaignid=web_share" className='play-store'></a>
                                </li>
                                <li>
                                    <a target='_blank' href="https://apps.apple.com/us/app/sharkskillz/id6714483981" className='app-store'></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Footer
